export enum AuditReportStatus {
    PROCESSING = 'PROCESSING',
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    EMPTY = 'EMPTY',
    FAILED = 'FAILED'
}
